import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { ErrorMessages } from '@/client/modules/Login/types'

export const schema = (texts: ErrorMessages) =>
  z
    .object({
      email: z.string().min(1, texts.required_error).email(texts.email_error),
      password: z.string().min(1, texts.required_error),
      new_password: z
        .string()
        .min(8, texts.min_length_error + ': 8')
        .max(256)
        .regex(
          /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
          {
            message: texts.password_error
          }
        )
        .optional(),
      confirm_password: z.string().optional() // We just check if it's the same as new_password
    })
    .refine((data) => data.new_password === data.confirm_password, {
      path: ['confirm_password'],
      message: texts.password_match_error
    })

export const schemaResolver = (texts: ErrorMessages) => zodResolver(schema(texts))
